import { render, staticRenderFns } from "./order-feedback-summary-row.vue?vue&type=template&id=0c59d298"
import script from "./order-feedback-summary-row.vue?vue&type=script&lang=js"
export * from "./order-feedback-summary-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports